import { VARIABLE_DATA_TYPES } from 'ts-components/inputs/ValueInput/types';
import { omitObjectKeys } from './ts-helpers';
import type { AutomationVariableDataType } from './types/common';

export const CONTENT_TYPE = {
  applicationJavascript: 'application/javascript',
  applicationXml: 'application/xml',
  applicationXhtmlXml: 'application/xhtml+xml',
  applicationJson: 'application/json',
  applicationXwwwFormUrlencoded: 'application/x-www-form-urlencoded',
  textPlain: 'text/plain',
  textHtml: 'text/html',
  textXml: 'text/xml',
  textCsv: 'text/csv',
} as const;

// how deeply loops may be nested: a loop is offered up to this depth, never inside one already at it
export const MAX_LOOP_DEPTH = 3;

export const MovingBranchOptions = {
  GoalCondition: 'goal_condition',
  MergedBranch: 'merged_branch',
  UnmergedBranch: 'unmerged_branch',
} as const;

export type MovingBranchType = ValueOf<typeof MovingBranchOptions>;

export const AUTOMATION_VARIABLE_DATA_TYPES = omitObjectKeys(
  VARIABLE_DATA_TYPES,
  [VARIABLE_DATA_TYPES.email]
);

// The array variables a loop is allowed to iterate. Cardinality is only offered
// for these three types, but a variable can arrive from the API as an array of
// anything, so the loop picker names what it accepts rather than taking every
// array it is handed.
export const LOOP_ARRAY_DATA_TYPES: Array<AutomationVariableDataType> = [
  AUTOMATION_VARIABLE_DATA_TYPES.entity,
  AUTOMATION_VARIABLE_DATA_TYPES.string,
  AUTOMATION_VARIABLE_DATA_TYPES.uuid,
];

export const VARIABLE_CARDINALITIES = {
  single: 'single',
  array: 'array',
} as const;

export const VALUE_SOURCE_TYPES = {
  SPECIFIC_VALUE: 'specific_value',
  RELATED_OBJECT_FIELD: 'related_object_field',
  CONTEXT_ENTITY_FIELD: 'context_entity_field',
  AUTOMATION_VARIABLE: 'automation_variable',
  AUTOMATION_ENTITY_VARIABLE_FIELD: 'automation_entity_variable_field',
  BLANK: 'blank',
} as const;
